export default {
  sm: `
  One base to connect<br> 
  the world<br>
  DATA CENTER GAK<br> 
  Global 
  `,
  md: `
  One base to connect<br> 
  the world<br>
  DATA CENTER GAK Global 
  `,
  lg: `
  One base to connect<br> 
  the world<br>
  DATA CENTER GAK Global 
  `,
  xxl: `
  One base to connect<br> 
  the world<br>
  DATA CENTER GAK<br> 
  Global 
  `,
};
